import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_493: DocMigration = {
  maxSchemaVersion: "0.0.493",
  description: "Add parentId to electrical rules",
  apply(json: any): any {
    for (const id in json.settings) {
      const setting = json.settings[id];

      if (setting.type !== "ELECTRICAL_SETTINGS") {
        continue;
      }

      for (const id in setting.rules) {
        const rule = setting.rules[id];
        rule.parentId = setting.id;
      }
    }

    return json;
  },
};

export default migration_0_0_493;
